import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { injectIntl } from 'react-intl';
import { ICollectionPoint, ICollectionPointUpdate, ICrossReference, ICrossReferenceUpdate, ISorter } from '../../util/DataModelInterface';
import { Form, InputGroup, ListGroup } from 'react-bootstrap';
import DataListInput from "react-datalist-input";
import SorterList from '../../components/SorterList';
import { getCollectionpointOperators, getSorters } from '../../util/StorageUtil';
import { emptyPoint, updateCollectionpointInfo } from '../../api/CollectionpointOperators';
import { ConfirmModal } from '../../components/ReportModals';

export interface ICollectionPointProps {
  intl: any;
  type: string;
  operatorId: string;
  point: ICollectionPoint;
  points: ICollectionPoint[];
  add: (point: ICollectionPointUpdate) => void;
  update: (point: ICollectionPointUpdate) => void;
  modal: () => void;
  error: (msg: string) => void;
  close: () => void;
}

export interface ICollectionPointState {
  point: ICollectionPoint;
  newRefs: ICrossReferenceUpdate[];
  addHidden: boolean;
  sorter: string;
  sorterName: string;
  newRefValue: string;
  exists: boolean;
  operator: string;
  confirmAdd: boolean;
  confirmClose: boolean;
}

export const cPointPages = {
  edit: 'edit',
  add: 'add',
  none: 'none'
};

class CollectionPoint extends React.Component<ICollectionPointProps, ICollectionPointState> {

  constructor(props: any) {
    super(props);
    this.state = {
      point: props.point,
      newRefs: [] as ICrossReferenceUpdate[],
      addHidden: true,
      sorter: '',
      sorterName: '',
      newRefValue: '',
      exists: true,
      operator: this.operatorName(props.point.info.operator_id),
      confirmAdd: false,
      confirmClose: false
    };
  }

  edited = () : boolean => {
    let edited = false;
    if( this.state.point.info.public_id !== this.props.point.info.public_id || this.state.point.info.name !== this.props.point.info.name ||
        this.state.point.info.location_lat !== this.props.point.info.location_lat || this.state.point.info.location_lon !== this.props.point.info.location_lon ||
        this.state.point.info.street_address !== this.props.point.info.street_address || this.state.point.info.zip_code !== this.props.point.info.zip_code ||
        this.state.point.info.city !== this.props.point.info.city || this.state.point.info.community !== this.props.point.info.community || this.state.newRefs.length !== 0 ||
        this.state.point.info.operational_state !== this.props.point.info.operational_state || this.state.point.info.dataser !== this.props.point.info.dataser || 
        this.state.point.info.container_point !== this.props.point.info.container_point || this.state.point.info.contact_info !== this.props.point.info.contact_info ){
      edited = true;
    } 
    return edited;
  }

  reset = () => {
    this.setState({ point: emptyPoint(),
                    newRefs: [] as ICrossReferenceUpdate[],
                    addHidden: true,
                    sorter: '',
                    sorterName: '',
                    newRefValue: '',
                    exists: true
    });
  }

  setCollectionPointInfo = () => {
    let newPoint = { info : { ...this.state.point.info, store_point: this.operatorType(this.props.operatorId) === 'STORE'}, 
    crossreferences: this.state.newRefs, collectionpoint_exists: this.state.exists } as ICollectionPointUpdate;
    newPoint.info.container_point = newPoint.info.container_point === null ? false : newPoint.info.container_point;
    newPoint.info.dataser = newPoint.info.dataser === null ? false : newPoint.info.dataser;

    updateCollectionpointInfo(newPoint).then((response) => {
      if(response === false || response.error) {
        this.props.error(response.error);
      } else {
        this.props.update(newPoint);
      }
    });
  }

  getReferences = (refs: string[]) => {
    const elements: {} [] = [];
    if (refs) {
      refs.forEach((ref : string, index) => {
        elements.push(
          <ListGroup.Item className="ListItemIntend" key={index}>{ref}</ListGroup.Item>
        );
      });
    }
    return elements;
  }

  getCrossReferenceList = () => {
    const elements: {} [] = [];
    if (this.state.point.crossreferences) {
      this.state.point.crossreferences.forEach((ref : ICrossReference, index) => {
        elements.push(
          <ListGroup.Item className="ListItem" key={index}>
            <span className="name">{ ref.sorter_name }</span>
            <ListGroup>
              { this.getReferences(ref.references) }
            </ListGroup>
          </ListGroup.Item>
        );
      });
    }
    return elements;
  };

  addCrossReference = (ref: string) => {
    let found = this.state.point.crossreferences.find(found => found.sorter_name === this.state.sorterName);
    if(found) {
      found.references.push(ref);
    } else {
      let cr = {sorter_name: "", references: [] as string[]} as ICrossReference;
      cr.sorter_name = this.state.sorterName;
      cr.references.push(ref);
      this.state.point.crossreferences.push(cr);
    }
    this.state.newRefs.push({sorter_id: this.state.sorter, reference_string: ref});
  }

  addDefaultCrossReference = (ref: string, sorter: ISorter) => {
    let found = this.state.point.crossreferences.find(found => found.sorter_name === sorter.name);
    if(found) {
      let refExists = found.references.includes(ref);
      if (!refExists) {
        found.references.push(ref);
        this.state.newRefs.push({sorter_id: sorter.id, reference_string: ref});
      }
    } else {
      let cr = {sorter_name: "", references: [] as string[]} as ICrossReference;
      cr.sorter_name = sorter.name;
      cr.references.push(ref);
      this.state.point.crossreferences.push(cr);
      this.state.newRefs.push({sorter_id: sorter.id, reference_string: ref});
    }
  }

  addRefView = () => {
    return(
      <div className={ this.state.addHidden ? 'hidden' : 'add-view' }>
        <InputGroup>
            <Form.Group controlId="sorterName">
              <Form.Label>{ this.props.intl.formatMessage({ id: 'settings.collectionpoints.add.sorter' }) }</Form.Label>
              <select className="form-control" id="sorter-select"
                  value={this.state.sorter}
                  onChange={(e) => {
                    this.setState({ sorter: e.target.value, sorterName: e.target.options[e.target.selectedIndex].text})
                  }}>
                { SorterList(this.props.intl) }
              </select>
            </Form.Group>
            <Form.Group controlId="crossreference">
              <Form.Label>{ this.props.intl.formatMessage({ id: 'settings.collectionpoints.crossreferences.add' }) }</Form.Label>
              <Form.Control className="card-text" size="sm" type="text" value={this.state.newRefValue}
                          placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.crossreferences.add'}) }
                          onChange={(e: any) => { this.setState({ newRefValue: e.target.value }) }}/>
            </Form.Group>
        </InputGroup>
        <div className="action-buttons">
          <button className="btn btn-secondary tiny-cancel-button"
                  onClick={() => { this.setState({sorterName: '', sorter: '', newRefValue: '', addHidden: !this.state.addHidden}); }}>
            {this.props.intl.formatMessage({id: 'settings.collectionpoints.crossreferences.add.cancel'})}
          </button>
          <button className="btn btn-primary tiny-ok-button" disabled={ !(this.state.newRefValue && this.state.sorter) }
                onClick={() => {  this.addCrossReference(this.state.newRefValue); // To view
                                  this.setState({sorterName: '', sorter: '', newRefValue: '', addHidden: !this.state.addHidden}); }} >
            {this.props.intl.formatMessage({id: 'settings.collectionpoints.crossreferences.add.ok'})}
          </button>
        </div>
      </div>);
  }

  operatorName = (id: string) => {
    let name = "";
    let operators = getCollectionpointOperators();
    if(operators) {
      let op = operators.find(op => op.id === id);
      if(op) {
        name = op.name;
      }
    }
    return(name);
  }

  operatorType = (id: string) => {
    let type = "";
    let operators = getCollectionpointOperators();
    if(operators) {
      let op = operators.find(op => op.id === id);
      if(op) {
        type = op.reportformat;
      }
    }
    return(type);
  }

  handlePointInfoKeyValueUpdate = (key: string, value: string) => {
    this.setState({point: {...this.state.point, info: {...this.state.point.info, [key]: value, }} } );
  }

  close = () => {
    this.reset();
    this.props.close();
  }

  addCollectionPoint = () => {
    const isStore = this.operatorType(this.props.operatorId) === 'STORE';
    if (!isStore) {
      const sorters = getSorters();
      if (sorters)
        sorters.forEach(sorter => this.addDefaultCrossReference(this.state.point.info.collectionpoint_id, sorter));
    }
    let newPoint = { info : { ...this.state.point.info, store_point: isStore },
                     crossreferences: this.state.newRefs, collectionpoint_exists: this.state.exists } as ICollectionPointUpdate;
    this.props.add(newPoint);
    this.close();
  }

  nameInput = () => {
    const onSelect = (selectedItem: any) => {
      this.setState({ point: selectedItem.point,
                      exists: true,
                      newRefs: [] as ICrossReferenceUpdate[],
                      sorter: '',
                      sorterName: '',
                      newRefValue: '',
                      operator: this.operatorName(selectedItem.point.info.operator_id),
                      confirmAdd: false,
                      confirmClose: false});
    };

    if(this.props.type === cPointPages.add) {
      return (
        <InputGroup>
          <Form.Group controlId="collectionPointName">
            <Form.Label>{ this.state.point.info.store_point ? 
                          this.props.intl.formatMessage({id: 'settings.collectionpoints.add.storepoint'}) :
                          this.props.intl.formatMessage({id: 'settings.collectionpoints.add.collectionpoint'})}</Form.Label>
            <DataListInput placeholder={this.props.intl.formatMessage({id:'point-list.choose'})}
                          items={ this.props.points.map((p: ICollectionPoint) => ({ label: p.info.name, key: p.info.collectionpoint_id, point: p as ICollectionPoint })) }
                          value={ this.state.point.info.name }
                          onSelect={ onSelect }
                          clearInputOnClick={true}
                          suppressReselect={false}
                          inputClassName={!this.state.point.info.name ? "missing-field form-control" : 'form-control'}
                          onInput={(e:any) => { this.setState({ point: emptyPoint(),
                                                                exists: false })
                                                this.handlePointInfoKeyValueUpdate('name', e); }}
                          match={(currentInput: any, item: any) => item.label.toLowerCase().includes(currentInput.toLowerCase())}/>
          </Form.Group>
        </InputGroup>);
    } else {
      return(
        <InputGroup>
          <Form.Group controlId="collectionPointName">
            <Form.Label>{ this.state.point.info.store_point ? 
                          this.props.intl.formatMessage({id: 'settings.collectionpoints.add.storepoint'}) :
                          this.props.intl.formatMessage({id: 'settings.collectionpoints.add.collectionpoint'})}</Form.Label>
            <Form.Control type="text" value={this.state.point.info.name}
                          onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('name', e.target.value); }}/>
          </Form.Group>
        </InputGroup>);
      }
  }

  inUseField = () => {
    return(
      <>
        <InputGroup className="my-4">
          <Form.Group controlId="inuse">
            <Form.Check type="checkbox">
              <Form.Check.Input type="checkbox" isValid checked={this.state.point.info.operational_state==='InUse'} disabled={this.props.type===cPointPages.add}
                                onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('operational_state', (e.target.checked ? 'InUse' : 'NotInUse')); }} />
              <Form.Check.Label>{this.props.intl.formatMessage({id: 'settings.collectionpoints.inuse'})}</Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </InputGroup>
        {this.props.type===cPointPages.add &&
        <InputGroup>
          <Form.Group controlId="inuse">
            <Form.Label className="card-text mandatory">
              { this.state.point.info.operator_id && (this.props.intl.formatMessage({id: 'settings.collectionpoints.hasoperator'}) +  this.state.operator ) }
            </Form.Label>
          </Form.Group>
        </InputGroup>}
      </>);
  }

  containers = () => {
    return(
      <InputGroup>
        <Form.Group controlId="dataser">
          <Form.Check type="checkbox">
            <Form.Check.Input type="checkbox" isValid checked={this.state.point.info.dataser} disabled={!this.state.point.info.store_point}
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('dataser', e.target.checked) }} />
            <Form.Check.Label>{this.props.intl.formatMessage({id: 'settings.collectionpoints.dataser'})}</Form.Check.Label>
          </Form.Check>
        </Form.Group>
        <Form.Group controlId="container">
          <Form.Check type="checkbox">
            <Form.Check.Input type="checkbox" isValid checked={this.state.point.info.container_point} disabled={!this.state.point.info.store_point}
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('container_point', e.target.checked) }} />
            <Form.Check.Label>{this.props.intl.formatMessage({id: 'settings.collectionpoints.container'})}</Form.Check.Label>
          </Form.Check>
        </Form.Group>
      </InputGroup>
    );
  }


  idInput = () => {
    if(this.props.type === cPointPages.add) {
      return(
        <Form.Group controlId="collectionpointsId">
          <Form.Label>{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.id'})}</Form.Label>
          <Form.Control className="card-text"
                        size="sm" type="text" value={ this.state.point.info.collectionpoint_id }
                        placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.id'}) }
                        onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('collectionpoint_id', e.target.value) }}/>
        </Form.Group>
      );
    } else {
      return(
        <Form.Group controlId="collectionpointsId">
          <Form.Label>{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.id'})}</Form.Label>
          <Form.Control className="card-text"
                        size="sm" type="text" value={ this.state.point.info.collectionpoint_id } disabled
                        />
        </Form.Group>
        );
    }
  }

  actionButton = () => {
    if(this.props.type === cPointPages.add) {
      return(
        <button disabled={ !this.state.point.info.name || !this.edited() }
                className="small-save-button btn btn-primary"
                onClick={() => { if(this.state.exists && this.state.point.info.operator_id !== "") this.setState({confirmAdd: true});
                                 else this.addCollectionPoint();}}>
          {this.props.intl.formatMessage({id: 'settings.operator.add.collectionpoint.add'})}
        </button>
      );
    } else {
      return(
        <button disabled={ !this.state.point.info.name || !this.edited() }
                className="small-save-button btn btn-primary"
                onClick={() => {
                  this.props.modal();
                  this.setCollectionPointInfo();
                  this.close();
                }}>
          {this.props.intl.formatMessage({id: 'settings.collectionpoints.save'})}
        </button>
      );
    }
  }

  render() {
    return (
      <div>
        <ConfirmModal
          modalOpen={this.state.confirmAdd}
          labelId={ this.state.point.info.store_point ? 'settings.collectionpoints.add.storepoint' : 'settings.collectionpoints.add.collectionpoint' }
          messageId={'settings.collectionpoint.collectionpoint.operator.confirm'}
          submitId={'settings.operator.add.collectionpoint.add'} dismissId={'settings.collectionpoints.cancel'}
          onDismiss={() => { this.setState({ confirmAdd: false });  }}
          onSubmit={() => { this.setState({ confirmAdd: false }); this.addCollectionPoint(); }} />
        <ConfirmModal
          modalOpen={this.state.confirmClose}
          labelId={ this.state.point.info.store_point ? 'settings.storecollectionpoint.header' : 'settings.collectionpoint.header' }
          messageId={'settings.collectionpoint.collectionpoint.close'}
          submitId={'settings.collectionpoints.close'} dismissId={'settings.collectionpoints.cancel'}
          onDismiss={() => { this.setState({ confirmClose: false });  }}
          onSubmit={() => { this.setState({ confirmClose: false }); this.close(); }} />
        <div className='sub-card-wrp mimic-modal'>
          <div className="sub-card-header">
            <h3>{ this.props.point.info.store_point ? 
                  this.props.intl.formatMessage({id: 'settings.storecollectionpoint.header' }) :
                  this.props.intl.formatMessage({id: 'settings.collectionpoint.header' }) }</h3>
          </div>
          <div className="sub-card-body" >
            {this.nameInput()}
            <InputGroup>
              {this.idInput()}
              <Form.Group controlId="publicid">
                <Form.Label>{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.publicid'})}</Form.Label>
                <Form.Control className="card-text"
                              size="sm" type="text" value={ this.state.point.info.public_id }
                              placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.publicid'}) }
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('public_id', e.target.value) }}/>
              </Form.Group>
            </InputGroup>
            <InputGroup>
              <Form.Group controlId="streetName">
                <Form.Label>{ this.props.intl.formatMessage({id: 'settings.collectionpoints.address'})}</Form.Label>
                <Form.Control className="card-text" size="sm" type="text" value={ this.state.point.info.street_address }
                              placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.street'}) }
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('street_address', e.target.value); }}/>
              </Form.Group>
            </InputGroup>
            <InputGroup>
              <Form.Group controlId="zip" className="col-md-2 noPadding">
                <Form.Label className="sr-only">{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.zip'})}</Form.Label>
                <Form.Control className="zip card-text" size="sm" type="number" value={ this.state.point.info.zip_code }
                              placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.zip'}) }
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('zip_code', e.target.value); }}/>
              </Form.Group>
              <Form.Group controlId="city" className="col-md-4 noPadding">
                <Form.Label className="sr-only">{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.city'})}</Form.Label>
                <Form.Control className="card-text" size="sm" type="text" value={ this.state.point.info.city }
                              placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.city'}) }
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('city', e.target.value); }}/>
              </Form.Group>
              <Form.Group controlId="community" className="col-md-6 noPadding">
                <Form.Label className="sr-only">{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.community'})}</Form.Label>
                <Form.Control className="card-text" size="sm" type="text" value={ this.state.point.info.community }
                              placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.community'}) }
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('community', e.target.value); }}/>
              </Form.Group>
            </InputGroup>
            <InputGroup>
              <Form.Group controlId="contactInfo">
                <Form.Label>{ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.contactinfo'})}</Form.Label>
                <Form.Control className="card-text" size="sm" type="text" value={ this.state.point.info.contact_info }
                              placeholder={ this.props.intl.formatMessage({id: 'settings.collectionpoints.placeholder.contactinfo'}) }
                              onChange={(e: any) => { this.handlePointInfoKeyValueUpdate('contact_info', e.target.value); }}/>
              </Form.Group>
            </InputGroup>
            {this.containers()}
            {this.inUseField()}
              <div className="d-flex flex-row align-items-center">
                <h4 className="card-title">{ this.props.intl.formatMessage({id: 'settings.collectionpoints.crossreferences'}) }</h4>
                <button className="btn btn-link ml-auto"
                        onClick={() => { this.setState({ addHidden: !this.state.addHidden });}}>
                  <FontAwesomeIcon className="LeftIcon" icon={ "plus-circle" } color="var(--serty-green)"/>
                  { this.props.intl.formatMessage({id: 'settings.collectionpoints.crossreferences.add'}) }
                </button>
              </div>
            { this.addRefView() }
            <ListGroup>
              { this.getCrossReferenceList() }
            </ListGroup>
          </div>
          <div className="card-buttons p-4 d-flex flex-row">
            <button className="btn btn-secondary small-cancel-button ml-auto"
                    onClick={() => {
                      if(this.edited()) {
                        this.setState({confirmClose: true});
                      } else { 
                        this.close();
                      }
                    }}>
              {this.props.intl.formatMessage({id: 'settings.collectionpoints.close'})}
            </button>
            { this.actionButton() }
          </div>
        </div>
      </div>
    );
  }
};

export default injectIntl(CollectionPoint);
